import React from 'react';
import Header from './components/Header';
import About from './components/About';
import Resume from './components/Resume';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import Seo from './components/Seo';
import resumeData from './resumeData';

function App() {
  return (
    <div className="App">
      <Seo resumeData={resumeData} />
      <Header resumeData={resumeData} />
      <main>
        <About resumeData={resumeData} />
        <Resume resumeData={resumeData} />
        <Portfolio resumeData={resumeData} />
        <Testimonials resumeData={resumeData} />
        <ContactUs resumeData={resumeData} />
      </main>
      <Footer resumeData={resumeData} />
    </div>
  );
}

export default App;
